export interface DuplicateHeaderGroup {
  name: string;
  indices: number[];
}

/**
 * Scan a list of CSV header names and return groups of duplicates.
 * Comparison is case-sensitive but whitespace-trimmed.
 * Returns groups in order of first appearance of each duplicated name.
 */
export function findDuplicateHeaders(headers: string[]): DuplicateHeaderGroup[] {
  const positions = new Map<string, number[]>();
  const order: string[] = [];

  headers.forEach((raw, idx) => {
    const name = raw.trim();
    if (!positions.has(name)) {
      positions.set(name, [idx]);
      order.push(name);
    } else {
      positions.get(name)!.push(idx);
    }
  });

  return order
    .filter((name) => positions.get(name)!.length > 1)
    .map((name) => ({ name, indices: positions.get(name)! }));
}
